import {
  getPlatform as _getPlatform,
  isMallIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform.js'

import { isMeicaiHarmony } from './get_app_info'

export const getPlatform = () => {
  if (isMallIOS() || isMCMallCirculationIOS() || isMCMallKeyCustomerIOS()) {
    return 'ios'
  }
  if (
    isMallAndroid() ||
    isMCMallCirculationAndroid() ||
    isMCMallKeyCustomerAndroid()
  ) {
    return 'android'
  }
  if (isMeicaiHarmony()) {
    return 'harmony'
  }
  if (_getPlatform() === 'pc') {
    return 'pc'
  }
  return 'weixin'
}
